module.exports = __webpack_public_path__ + "static/media/test10_1.c623a296.png";